import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'questionCountForm',
  ];

  questionCountFormToggleDisplay(event) {
    if (!this.hasQuestionCountFormTarget) return;

    this.questionCountFormTarget.hidden = !event.target.checked;
    this.questionCountFormTarget.querySelector('input').value = 0;
  }
}
